/**
 * service request type enum
 */
export enum ServiceRequestTypeEnum {
  EQUIPMENT = 'Equipment',
  HAND_CARRY = 'Hand Carry',
  INTERNAL = 'Internal',
  NEXT_FLIGHT_OUT = 'Next Flight Out',
  ORGAN = 'Organ',
  SPECIMEN = 'Specimen',
  TEAM = 'Team',
}
